import { type IResponseEventActivityCreated } from 'entities/Activity/api/types'
import { useEventActivityCreated } from 'entities/Activity/events/EventActivityCreated'
import { type ConversationMessagesStore } from 'widgets/ConversationMessages'

export const useEventConversationActivityCreated = (
  conversationMessageStore: ConversationMessagesStore
) => {
  const handler = (data: IResponseEventActivityCreated) => {
    if (
      data.activity_log.conversation_id === conversationMessageStore.conversationId &&
      conversationMessageStore.isShowActivity
    ) {
      conversationMessageStore.setItems([data.activity_log])
    }
  }

  useEventActivityCreated(handler)
}
